import './App.css'
import {Routes, Route, Navigate} from 'react-router-dom'
import LoginPage from './components/loginpage/LoginPage'
import WelcomePage from './components/welcomepage/WelcomePage'
import MainPage from './components/mainpage/MainPage'
import AuthGate from './components/AuthGate'
import CreationPage from "./components/creationpage/CreationPage";
import PaymentReminderPage from './components/paymentreminderpage/PaymentReminderPage'

export default function App() {
    return (
        <Routes>
            <Route path='/login' element={<LoginPage/>}/>

            <Route
                path='/welcome'
                element={
                    <AuthGate>
                        <WelcomePage/>
                    </AuthGate>
                }
            />

            <Route
                path='/'
                element={
                    <AuthGate>
                        <MainPage/>
                    </AuthGate>
                }
            />

            <Route
                path='/creationpage'
                element={
                    <AuthGate>
                        <CreationPage isCreation={true} />
                    </AuthGate>
                }
            />

            <Route
                path='/editingpage/:invoiceId'
                element={
                    <AuthGate>
                        <CreationPage isCreation={false} />
                    </AuthGate>
                }
            />

            <Route
                path='/payment-reminders'
                element={
                    <AuthGate>
                        <PaymentReminderPage/>
                    </AuthGate>
                }
            />

            <Route path='*' element={<Navigate to='/' replace/>}/>
        </Routes>
    )
}
